(function(definition){
    "use strict";

    var moduleName = "childNav";

    var root = (typeof self === "object" && self.self === self && self) || (typeof global === "object" && global.global === global && global);

    if (typeof exports === "object"){
        module.exports = definition(root, require("jquery"));
    } else {
        root[moduleName] = definition(root, $);
    }

})(function(root, $){
    "use strict";

    // -------------------------------------------------------
    // utility functions
    // -------------------------------------------------------
    const isUndefined = (obj)=>{ return obj === void 0; };
    const trimDot = (string)=>{ return string.replace(".", ""); };
    const trimSome = (string, some)=>{ return string.replace(some, ""); };
    const putBothClasses = (string, prefix)=>{ return trimDot(string) + " " + trimSome(trimDot(string), prefix); };

    /**
     * module factory
     * this module is dependent on jQuery
     * @prop {string} rootElement default root element class or id
     * @prop {array} instance
     * @namespace
     */
    function factory(param){

        var rootElement = ".js-childNav";
        var opt = !isUndefined(param) ? param : {};

        var $list;
        if (isUndefined(opt.root)) $list = $(rootElement);
        if (!isUndefined(opt.root)) $list = opt.root instanceof $ ? param.root : $(param.root);

        var length = $list.length;
        var mappedlist = [];
        for (var i = 0; i < length; i++) {
            mappedlist[i] = new Module(opt, $list[i]);
        }
        return mappedlist;
    }

    /**
     * constructor
     * @type {Function}
     */
    function Module(opt, moduleRoot){

        this.rootclass = moduleRoot;

        // options
        this.opt = {
            //elements
            trigger: !isUndefined(opt.trigger) ? opt.trigger : ".js-childNav__trigger",
            item: !isUndefined(opt.item) ? opt.item : ".js-childNav__item",
        };

        // elements
        this.$root = $(moduleRoot);
        this.$trigger = this.$root.find(this.opt.trigger);
        this.$item = this.$root.find(this.opt.item);

        // state
        this.isAnimation = false

        // init
        this.init();
    }


    Module.prototype.init = function(){
        this.setHoverEvent();
        return this;
    };

    Module.prototype.setHoverEvent = function(){
        this.$root.hover(
            ()=>{
                if(this.isAnimation) return;

                this.isAnimation = true;
                this.$item.fadeIn(300, ()=>{
                    this.isAnimation = false;
                });
            },
            ()=>{
                if(this.isAnimation) return;

                this.isAnimation = true;
                this.$item.fadeOut(300, ()=>{
                    this.isAnimation = false;
                });
            }
        );
        return this;
    };

    return factory;
});
